import { render, staticRenderFns } from "./SamTooltip.vue?vue&type=template&id=122344b4&scoped=true&"
import script from "./SamTooltip.vue?vue&type=script&lang=js&"
export * from "./SamTooltip.vue?vue&type=script&lang=js&"
import style0 from "./SamTooltip.vue?vue&type=style&index=0&id=122344b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122344b4",
  null
  
)

export default component.exports